import { stepSchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as z from "zod/v4";

export const generateOmsAutomation = {
  name: "generateOmsAutomation" as const,
  input: z.object({
    description: z
      .string()
      .describe("Natural language description of the automation to create"),
  }),
  output: z.object({
    success: z.boolean(),
    flow: z.object({ name: z.string(), steps: z.array(stepSchema) }).optional(),
    warnings: z.array(z.string()).optional(),
    error: z.string().optional(),
  }),
};
